(function() {
    $(document).ready(function() {
        var $siteSearchInputSection = $('.site-search-input');

        $('.js-close-site-search').click(function() {
            $siteSearchInputSection.slideUp();
            $('.js-site-header').removeClass('searchIsExpanded');
        });

        $('.js-site-search-trigger').click(function() {
            $siteSearchInputSection.slideDown();
            $('.js-site-header').addClass('searchIsExpanded');
            $('.site-search_input').focus();
        });

    });
})();




var getUrlVars = function () {
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        vars[hash[0]] = hash[1];
    }
    return vars;
}



var removeFilters = function (filters) {
    for (var i = 0; i < filters.length; i++) {
        if (filters[i].filter == "ALL") {
            origNumber--;
            continue;
        }

        RemoveFilterAjax(filters, filters[i]);
    }
}

var RemoveFilterAjax = function (allfilts, filt) {
    $.ajax({
        //url: "https://www.googleapis.com/customsearch/v1?key=" + SiteSearchFilterVars.apiKey + "&cx=" + SiteSearchFilterVars.cx + "&q=" + getUrlVars().query + "filter=" + filt.filter + "&fields=searchInformation(totalResults)",
        url: "/api/sitecore/sitesearch/FilterSearch?q=" + getUrlVars().query + "&filter=" + filt.filter + "&fields=searchInformation(totalResults)",
        type: "GET",
        context: this,
        success: function (data) {
            if (data.TotalResults < 1) {
                for (var j = 0; j < allfilts.length; j++) {
                    if (filt.filter == allfilts[j].filter) {
                        allfilts.splice(j, 1);
                        break;
                    }
                }
            }
            origNumber--;
            if (origNumber < 0)
                filterViewModel.filters(allfilts);
        },
        error: function (data) {
            console.log("error", data);
        }
    });
}

if (document.getElementById("site-search-filters"))
    ko.applyBindings(filterViewModel, document.getElementById("site-search-filters"));

if (typeof(SiteSearchFilterVars) != 'undefined') {
    var origFilts = SiteSearchFilterVars.origFilts;
    if (origFilts) {
        var origNumber = origFilts.length - 1;
        removeFilters(origFilts);
    }
}